import { useTranslation } from "react-i18next";
import { Props, PositionDateOptionValue, PositionDateQuickFilter } from "./interfaces";
import { QuickFilterOption } from "../../../reusable-components/QuickFilter/interfaces";

import QuickFilter from "../../../reusable-components/QuickFilter/QuickFilter";

export const PositionDateQuickfilter = <Q extends PositionDateQuickFilter>({
  quickFilters,
  handleChangeQuickFilters,
}: Props<Q>) => {
  const { t } = useTranslation();
  const tRP = "components.quickfilters.position_date"; // tRP - translation root path

  const options: QuickFilterOption<PositionDateOptionValue>[] = [
    {
      name: t(`${tRP}.any_time_period`),
      value: { fromMonthsAgo: null },
    },
    {
      name: t(`${tRP}.last_month`),
      value: { fromMonthsAgo: 1 },
    },
    {
      name: t(`${tRP}.last_three_month`),
      value: { fromMonthsAgo: 3 },
    },
    {
      name: t(`${tRP}.last_six_month`),
      value: {
        fromMonthsAgo: 6,
      },
    },
    {
      name: t(`${tRP}.last_twelve_month`),
      value: { fromMonthsAgo: 12 },
    },
  ];

  return (
    <QuickFilter
      options={options}
      quickFilters={quickFilters}
      quickFilter="positionDate"
      handleChangeQuickFilter={handleChangeQuickFilters}
      shrinkedLabel={t(`${tRP}.shrinked_label`)}
    />
  );
};
